import {useCallback} from "react";
import {useComputed, useSignal} from "@preact/signals-react";
import {useAppToast} from "@ui-seeker/app";
import {postSubmit} from "@ui-seeker/utils";

import {BACKEND_APIS} from "@constants";
import {matcherSKUDrawerData, matcherSKUDrawerError, reloadBrandSkus} from "../@signals";


export default function useMatchersSkusForm(field='') {
	const isLoading = useSignal(false)
	const localValue = useComputed(() => matcherSKUDrawerData.value[field])

	const { showToast } = useAppToast()

	const handleChange = useCallback((newValue, newData={}) => {
		matcherSKUDrawerData.value = {
			...matcherSKUDrawerData.value,
			[field]: newValue,
			...newData
		}
	}, [])

	const handleSubmit = useCallback(() => {
		isLoading.value = true
		showToast.promise(postSubmit(`${BACKEND_APIS.SKU_DATA}/update-sku`, {
			companyID: matcherSKUDrawerData.value.companyID === 'null' ? null : matcherSKUDrawerData.value.companyID,
			skuID: null,
			brandID: matcherSKUDrawerData.value.brandID,
			categoryID: matcherSKUDrawerData.value.categoryID,
			lineID: matcherSKUDrawerData.value.lineID,
			ean: matcherSKUDrawerData.value.ean,
			skuName: matcherSKUDrawerData.value.productTitle,
			genderID: matcherSKUDrawerData.value.gender,
			customerID: matcherSKUDrawerData.value.customerID,
			size: matcherSKUDrawerData.value.size,
			imageUrl: matcherSKUDrawerData.value.thumbnail,
			unitySize: matcherSKUDrawerData.value.unitySize,
			validated: true,
			availablePricing: matcherSKUDrawerData.value.availablePricing || false,
			availableMarketplaces: matcherSKUDrawerData.value.availableMarketplaces || false,
			availableMonitoring: matcherSKUDrawerData.value.availableMonitoring || false
		}), {
			onSuccess: res => {
				isLoading.value = false
				matcherSKUDrawerData.value = {}
				matcherSKUDrawerError.value = {}
				reloadBrandSkus()
				return 'SKU created successfully'
			},
			onError: res => {
				isLoading.value = false
				if (res.status === 403)
					return 'SKU already exists in the database.'
			}
		})
	}, [])

	return {
		localValue: localValue.value,
		isLoading: isLoading.value,

		handleChange,
		handleSubmit
	}
}